<template>
  <code :class="styled ? 'px-2 py-1 bg-gray-700 text-white rounded-md' : ''" @dblclick="select_and_copy">
    <slot />
  </code>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    styled?: boolean;
  }>(),
  { styled: true },
);

function select_and_copy(event: MouseEvent) {
  const node = event.currentTarget as Node;

  const range = document.createRange();
  range.selectNode(node);
  window.getSelection()?.removeAllRanges();
  window.getSelection()?.addRange(range);

  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(node.textContent!);
  } else {
    document.execCommand("copy");
  }

  setFlashMessage({ type: "success", message: "Copied", durationMs: 2000 });
}
</script>
>
